export default __webpack_public_path__ + "static/media/commonroad-search-code-example.e40a8348.md";